const interviewsSummary = (
  <div className="interview-boost-summary">
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Hearing back from applications</h3>
      <ul className="list-disc pl-6">
        <li>Most people only get responses from 1-3% of applications—don't be discouraged!</li>
        <li>Apply early (within 48 hours of a job posting) to increase your chances</li>
        <li>Networking and referrals significantly boost your odds of landing interviews</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Tools to Save Time</h3>
      <ul className="list-disc pl-6">
        <li>
          Try{' '}
          <a
            href="https://simplify.jobs/"
            className="text-blue-600 hover:text-blue-800 hover:underline"
          >
            Simplify.jobs
          </a>{' '}
          – a browser extension that autofills applications for you
        </li>
        <li>Use InternHub's application tracker to keep track of your applications</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Networking Strategies</h3>
      <ul className="list-disc pl-6">
        <li>
          If you don’t know anyone in tech, start by joining online communities, hackathons, and
          LinkedIn groups
        </li>
        <li>Reaching out to connections—even distant ones—can lead to valuable referrals</li>
        <li>Updating your LinkedIn with relevant keywords can help recruiters find you</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Optimizing Your Application</h3>
      <ul className="list-disc pl-6">
        <li>Don’t worry about matching every job requirement—companies are often flexible</li>
        <li>A strong portfolio showcasing your projects can make your application stand out</li>
        <li>Tailoring your resume and cover letter for each job improves your chances</li>
      </ul>
    </div>
  </div>
);

export default interviewsSummary;
